/**
 * Adscripción del empleado en una línea: área primero, dirección como contexto.
 *
 * Van juntas porque son la misma dimensión —dónde trabaja—, mientras que el
 * puesto responde a otra —qué hace— y por eso se muestra aparte. Es el mismo
 * agrupamiento que usan las tablas (columna "Área / Dirección").
 *
 * Existe como helper y no como componente porque lo único que se repite es la
 * regla de armado: omitir el que falte y no dejar separadores sueltos.
 *
 * Vive fuera de `vacaciones.helpers` porque no es de vacaciones: lo usan tanto
 * las solicitudes como el modal de cambio de área. El parámetro es estructural
 * —cualquier registro con `area` y `direccion`— para que sirva igual a una
 * `SolicitudVacaciones` que a un `EmpleadoList`.
 */
export function describirAdscripcion(
  registro: { area?: string | null; direccion?: string | null } | null | undefined,
): string {
  if (!registro) return '—';
  return [registro.area, registro.direccion].filter(Boolean).join(' · ') || '—';
}
